import { useMutation, gql } from '@apollo/client';
import { translate } from 'javascripts/translations/i18n';
import toast from 'helpers/toast';
import { Steven } from 'helpers/steven';
import { graphQLIdDecoder } from 'helpers/graphql-utils';
import { PROJECT_TASK_SOURCE } from 'data/v3';

const DELETE_PROJECT_TASK = gql`
  mutation DeleteProjectTask($input: ProjectTaskDeleteInput!) {
    projectTaskDelete(input: $input) {
      errors {
        error
        message
      }
      deletedId
    }
  }
`;
const useDeleteProjectTask = ({ taskId, source }) => {
  const sourceIsAsset =
    source === PROJECT_TASK_SOURCE.PHOTO ||
    source === PROJECT_TASK_SOURCE.VIDEO;

  const [deleteProjectTaskMutation] = useMutation(DELETE_PROJECT_TASK, {
    onCompleted: (response) => {
      const errors = response.projectTaskDelete?.errors;
      if (errors?.length) {
        toast.error(errors[0].message);
        return;
      }

      const deletedId = response.projectTaskDelete?.deletedId;
      const deletedDbId = graphQLIdDecoder(deletedId)?.databaseId;

      if (deletedDbId) {
        Steven.entityCrud({
          entity_id: deletedDbId,
          entity_type: 'project_task',
          action: 'deleted',
          source,
        });
      }

      toast.success(translate('projectTasks.deleteTaskSuccessMsg'));
    },
    onError: () => {
      toast.error(translate('projectTasks.deleteTaskErrorMsg'));
    },
    // Refetching instead of updating to get correct position values of tasks
    refetchQueries: [
      'GetProjectTasks',
      sourceIsAsset ? 'GetAssetProjectTasks' : null,
    ],
  });

  const deleteProjectTask = async () => {
    await deleteProjectTaskMutation({
      variables: {
        input: {
          id: taskId,
        },
      },
    });
  };

  return {
    deleteProjectTask,
  };
};

export default useDeleteProjectTask;
